import script from "./TextQuote.vue?vue&type=script&setup=true&lang=js"
export * from "./TextQuote.vue?vue&type=script&setup=true&lang=js"

import "./TextQuote.vue?vue&type=style&index=0&id=5a1d105b&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1d105b"]])

export default __exports__